import { Icon, Props } from "./UploadIcon.Parts";

export const UploadIcon = ({ small, ...props }: Props) => (
  <Icon
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    $small={small}
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.875 15.3125V18.125H6.125V15.3125H4V18.125C4 19.1563 4.95625 20 6.125 20H18.875C20.0438 20 21 19.1563 21 18.125V15.3125H18.875ZM7.1875 9.6875L8.68562 11.0094L11.4375 8.59062V16.25H13.5625V8.59062L16.3144 11.0094L17.8125 9.6875L12.5 5L7.1875 9.6875Z"
    />
  </Icon>
);
